import React from 'react';
import { useIsDevelopment } from '../hooks/useEnvironment';

export const DevBanner: React.FC = () => {
  const isDevelopment = useIsDevelopment();

  if (!isDevelopment) {
    return null;
  }

  return (
    <div
      className="bg-red-600 text-white text-center py-2 px-4 text-sm font-medium"
      data-testid="dev-banner"
    >
      <span className="inline-flex items-center">
        🚧 DEVELOPMENT ENVIRONMENT 🚧
        <span className="ml-2 text-xs opacity-90">
          (tabpicker.pages.dev)
        </span>
      </span>
    </div>
  );
};